

































import demo1 from './demo1.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import DInputNumber from '@/packages/d-input-number';
import title from '../../packages/d-input-number/demo/README.md';

Vue.use(Anchor);
Vue.use(DInputNumber);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1
  }
})
export default class ComponentDemo extends Vue {
  public title = title;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
